import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import ReactDOM from 'react-dom';
import { OV_ALERT } from '../../config/constants';
import AlertOverlay from '../../components/AlertOverlay';
import { jsx as _jsx } from "react/jsx-runtime";

var init = function init() {
  // Alerts
  var showAlert = function showAlert(event) {
    var id = event.detail.title;

    if (document.getElementById(id)) {
      return;
    }

    var alert = document.createElement('div');
    alert.id = id;
    document.body.appendChild(alert);
    ReactDOM.render( /*#__PURE__*/_jsx(AlertOverlay, _objectSpread({}, event.detail)), alert);
  }; // Listen to the global OV_ALERT event and display the alert


  window.addEventListener(OV_ALERT, showAlert);
};

export default init;